import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import ArtCard from "./art-card";

const artists = [

    {
    name: "CHARLES ANDREW",
    sort: "CHARLES ANDREW",
    link: "https://charlieandrew02eb.myportfolio.com/?fbclid=PAQ0xDSwLA5O9leHRuA2FlbQIxMQABp1XBkq7Cm-dmOkM0WHj4_vwmI1zJjzpc0DmKu8XEuh8mt0cxKSoRyN-8sEq7_aem_zDMwt4JuMss4LYdaOMHIJA",
    img: "charlie.png",
  },
  {
    name: "GARROW WILSON",
    sort: "GARROW WILSON",
    link: "https://www.instagram.com/rum_and_croak/",
    img: "garrow.jpg",
  },
    {
    name: "Hannah Hewitt",
    sort: "Hannah Hewitt",
    link: "https://www.instagram.com/hh3w1tt/",
    img: "hannah.png",
  },
  {
    name: "JAYDEN ROY CROOKS",
    sort: "JAYDEN ROY CROOKS",
    link: "https://jaydenrcrooks.myportfolio.com/",
    img: "jayden.jpeg",
  },
  {
    name: "LINDSAY JOHNSTONE",
    sort: "LINDSAY JOHNSTONE",
    link: "https://www.instagram.com/lrj.art/?hl=en",
    img: "lj.png",
  },
    {
    name: "Lucy Grainge",
    sort: "Lucy Grainge",
    link: "https://www.instagram.com/_lucygr/?hl=en",
    img: "lucywilderness.jpg",
  },
  {
    name: "MADELEINE EDWARDS",
    sort: "MADELEINE EDWARDS",
    link: "https://www.instagram.com/madeleinedwards",
    img: "madeline.jpg",
  },
  {
    name: "MOZE",
    sort: "MOZE",
    link: "https://www.instagram.com/ermitsmoze/?hl=en",
    img: "moze.jpg",
  },
  {
    name: "NAFTYS",
    sort: "NAFTYS",
    link: "https://www.instagram.com/naftys_/?hl=en",
    img: "nafty.png",
  },
  {
    name: "SOPHIE EGLETON",
    sort: "SOPHIE EGLETON",
    link: "https://www.instagram.com/sveggs_ink/?hl=en",
    img: "sophie.jpg",
  },
  {
    name: "VISUAL ARCHITECTS",
    sort: "VISUAL ARCHITECTS",
    link: "https://visual-architects.com/",
    img: "visualarch.png",
  },
  {
    name: "Innerstrings Visuals",
    sort: "Innerstrings Visuals",
    link: "https://www.instagram.com/innerstrings/",
    img: "innerstrings.jpg",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function Art() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}>
        {sortedArtists.map((artist) => (
          <ArtCard key={artist.name} artist={artist} />
        ))}
      </Box>
    </Container>
  );
}
export default Art;
